module.exports = __webpack_public_path__ + "static/img/ns.67ec129a.png";